/**
 * Whether the shop is trading yet, and how to say so. Shop details carries a
 * "trading" switch and an optional opening date. Trading is true when the
 * switch is on, or when the opening date has arrived in London; otherwise the
 * site says the shop is opening and hides the ways to order.
 */
export interface OpeningDetails {
  trading: boolean;
  openingDate: string | null;
}

/** YYYY-MM-DD for the given instant in Europe/London. */
export function londonDate(now: Date): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/London',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
}

export function isTrading(now: Date, details: OpeningDetails): boolean {
  if (details.trading) return true;
  if (details.openingDate) return londonDate(now) >= details.openingDate;
  return false;
}

/** "Opening Friday 20 October", or "Opening soon" when no date is set. */
export function openingLine(openingDate: string | null): string {
  if (!openingDate) return 'Opening soon';
  const [y, m, d] = openingDate.split('-').map(Number);
  const date = new Date(Date.UTC(y!, m! - 1, d!));
  const words = new Intl.DateTimeFormat('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone: 'UTC',
  }).format(date);
  return `Opening ${words}`;
}
